
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import {
  User as PerformoUser,
  UsersApi,
  ValidationProblemDetails,
  Workorder,
  WorkordersApi,
  PerformoSettings
} from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {},
  computed: mapGetters({
    ordersApi: 'ordersApi',
    usersApi: 'usersApi',
    settings: 'settings'
  })
})
export default class CompleteOrderComponent extends Vue {
  private ordersApi!: WorkordersApi;
  private usersApi!: UsersApi;
  private settings!: PerformoSettings;
  private showDialog = false;
  private isLoading = false;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false, type: Boolean })
  private actionBar!: boolean;

  private validationProblems: ValidationProblemDetails = {};

  @Watch('showDialog')
  private resetValidationProblems() {
    this.validationProblems = [];
  }

  private completeOrderHandler() {
    if (this.settings.completeConfirmation) {
      this.showDialog = true;
    } else {
      // if complete confirmation is turned off, just complete the order
      this.completeOrder();
    }
  }

  private completeOrder() {
    if (!this.order || !this.order.workorderId) {
      return;
    }
    this.isLoading = true;
    this.$emit('loading', true);
    this.ordersApi
      .completeOrder({
        workorderCompleteCommand: {
          workorderId: this.order.workorderId || ''
        }
      })
      .then(this.completeSuccessHandler)
      .catch(this.errorHandler)
      .finally(() => {
        this.isLoading = false;
        this.$emit('loading', false);
      });
  }

  private cancelComplete() {
    this.showDialog = false;
    this.dialogDone();
  }

  private completeSuccessHandler(order: Workorder) {
    // when order is successfully completed, update the state in vuex with current user profile
    this.usersApi
      .getMyProfile()
      .then((pmoUser: PerformoUser) =>
        this.$store.commit('setPerformoUser', pmoUser)
      );

    this.$emit('completed', order);
    this.showDialog = false;
    this.dialogDone();
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    if (
      !this.settings.completeConfirmation &&
      this.validationProblems &&
      this.validationProblems.errors
    ) {
      handleApiError(error);
    }
    this.$emit('complete-error');
  }

  private dialogDone() {
    this.$emit('dialog-done');
  }
}
